import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import { logout, getUserInfo, isAdmin, canViewLoginActivity, canUseUsco } from '../utils/auth';

function Home() {
  const navigate = useNavigate();
  const userInfo = getUserInfo();

  const reports = {
    warehouseProductivity: [
      { id: 'warehouse-dispatched', name: 'Dispatched Orders', available: true, hidden: true },
      { id: 'warehouse-open', name: 'Open Orders', available: true, hidden: true },
      { id: 'warehouse-hybrid', name: "Warehouse Performance Stats", available: true }
    ],
    pickerProductivity: [
      { id: 'dispatched-orders', name: 'Dispatched Orders', available: true },
      { id: 'open-orders', name: 'Open Orders', available: true }
    ],
    trackWork: [
      { id: 'open-orders-track', name: 'Open Orders', available: false }
    ]
  };

  const handleReportClick = (reportId, available) => {
    if (available) {
      navigate(`/${reportId}`);
    }
  };

  const handleLogout = () => {
    logout();
    // Force reload to clear all state and redirect to login
    window.location.href = '/login';
  };

  return (
    <div className="home-container">
      <header className="home-header">
        <div className="header-top">
          <div>
            <h1>ITR America</h1>
            <h2>Business Intelligence Reporting</h2>
          </div>
          <div className="user-info">
            {userInfo && (
              <>
                {isAdmin() ? (
                  <button className="admin-btn" onClick={() => navigate('/admin')}>Control Panel</button>
                ) : canViewLoginActivity() && (
                  <button className="admin-btn" onClick={() => navigate('/admin')}>Login Activity</button>
                )}
                <span className="welcome-text">Welcome, {userInfo.fullName || userInfo.username}</span>
                <button className="logout-btn" onClick={handleLogout}>Logout</button>
              </>
            )}
          </div>
        </div>
      </header>

      <div className="reports-grid">
        <div className="report-category">
          <h3>Warehouse Productivity Reports</h3>
          <div className="report-cards">
            {reports.warehouseProductivity.filter(r => !r.hidden).map((report) => (
              <div
                key={report.id}
                className={`report-card ${!report.available ? 'disabled' : ''}`}
                onClick={() => handleReportClick(report.id, report.available)}
              >
                <h4>{report.name}</h4>
                {!report.available && <span className="coming-soon-badge">Coming Soon</span>}
              </div>
            ))}
          </div>
        </div>

        <div className="report-category">
          <h3>Picker Productivity Reports</h3>
          <div className="report-cards">
            {reports.pickerProductivity.map((report) => (
              <div
                key={report.id}
                className={`report-card ${!report.available ? 'disabled' : ''}`}
                onClick={() => handleReportClick(report.id, report.available)}
              >
                <h4>{report.name}</h4>
                {!report.available && <span className="coming-soon-badge">Coming Soon</span>}
              </div>
            ))}
          </div>
        </div>

        <div className="report-category">
          <h3>Track Work Reports</h3>
          <div className="report-cards">
            {reports.trackWork.map((report) => (
              <div
                key={report.id}
                className={`report-card ${!report.available ? 'disabled' : ''}`}
                onClick={() => handleReportClick(report.id, report.available)}
              >
                <h4>{report.name}</h4>
                {!report.available && <span className="coming-soon-badge">Coming Soon</span>}
              </div>
            ))}
          </div>
        </div>

        {canUseUsco() && (
          <div className="report-category">
            <h3>Intercompany Tools</h3>
            <div className="report-cards">
              <div className="report-card" onClick={() => navigate('/usco-converter')}>
                <h4>USCO Converter</h4>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
